import type {CacheKeys} from 'src/hooks/common-data-service/cached-table';

export enum ActivityLogSortFields {
    START_DATE = 'START_DATE',
}

export type ActivityLogCacheKeys = CacheKeys<undefined, ActivityLogSortFields, undefined>;
